<template>
  <FormViewTemplate
    :backButtonRoute="'/settings/company'"
    :dataModel="model"
    :toolbarOptions="toolbarOptions"
    :formItems="setFormItems"
    :saveModel="saveModel"
    :pageData="pageData"
  />
</template>

<script>
import { CompanyService } from "../../../_services/api/accounts/company.service.js";
import FormViewTemplate from "../../../templates/form-view";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

export default {
  props: {},

  components: { FormViewTemplate },
  async created() {},

  data() {
    return {
      pageData: {
        route: "/company",
        name: "Company",
        readEndpoint: "Company",
        expand: "CompanyImagesMetas",
        saveEndpoint: "Company",
        createTitle: "Create Company",
      },
      model: {
        AbaUserCode: "",
        Abn: "",
        Acn: "",
        Code: "",
        CurrencyCode: "",
        Fax: "",
        GroupNo: "",
        Gs1Code: "",
        Inactive: "",
        LogoImageId: "",
        Image: null,
        ImageSrc: "",
        ImageType: undefined,
        ImageName: undefined,
        CompanyImagesMetas: undefined,
        PreviewImageSrc: "",
        OriginalImageBlobName: "",
        Name: "",
        ParentCode: "",
        Phone: "",
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
        MailAddressCountry: "",
        MailAddressPostcode: "",
        MailAddressState: "",
        MailAddressStreetLine1: "",
        MailAddressStreetLine2: "",
        MailAddressSuburb: "",
        PublicOfficer: "",
        Std: "",
        SetAsPostalAddress: false,
        TaxCode: "",
        TaxNo: "",
        UltimateHoldingCompanyCode: "",
        Website: "",
        RecordId: undefined,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        IsPostalData: false,
        FriendlyName: "",
        DefaultEmail: "",
        DefaultEmailAlias: "",
      },
      saveModel: {
        AbaUserCode: "",
        Abn: "",
        Acn: "",
        Code: "",
        CurrencyCode: "",
        Fax: "",
        GroupNo: "",
        Gs1Code: "",
        Inactive: "",
        Image: "",
        ImageSrc: "",
        ImageType: undefined,
        ImageName: undefined,
        Name: "",
        ParentCode: "",
        Phone: "",
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
        MailAddressCountry: "",
        MailAddressPostcode: "",
        MailAddressState: "",
        MailAddressStreetLine1: "",
        MailAddressStreetLine2: "",
        MailAddressSuburb: "",
        PublicOfficer: "",
        Std: "",
        SetAsPostalAddress: "",
        TaxCode: "",
        TaxNo: "",
        UltimateHoldingCompanyCode: "",
        Website: "",
        FriendlyName: "",
        DefaultEmail: "",
        DefaultEmailAlias: "",
        RecordId: "",
      },
      formOptions: {
        gcLabelLocation: "left",
      },

      toolbarOptions: {
        save: true,
        audit: true,
        toolbarFormItems: [
          {
            dataField: "Name",
            width: 500,
            label: { text: "Company", visible: false },
            labelVisible: false,
            editorType: "dxTextBox",
            editorOptions: {
              disabled: true,
              maxLength: 50,
            },
          },
        ],
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  disabled: true,
                },
              },
            ],
          },
        ],
      },
    };
  },
  mixins: [RouteMixin, FormMixin],
  computed: {
    setVisible() {
      return this.model["SetAsPostalAddress"] ? false : true;
    },
    setFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  items: [
                    {
                      screenField: "PhysicalAddressStreetLine1",
                      required: true,
                    },
                    {
                      screenField: "PhysicalAddressStreetLine2",
                    },
                    {
                      screenField: "PhysicalAddressSuburb",
                      required: true,
                    },
                    {
                      screenField: "PhysicalAddressState",
                      required: true,
                    },
                    {
                      screenField: "PhysicalAddressPostcode",
                      required: true,
                    },

                    {
                      screenField: "PhysicalAddressCountry",
                      required: true,
                    },

                    {
                      screenField: "Phone",
                      required: true,
                    },

                    {
                      screenField: "SetAsPostalAddress",
                      editorOptions: {
                        onValueChanged: (e) => {
                          if (!e.previousValue && e.value)
                            this.clearMailAddress();
                        },
                        onInitialized: (e) => {
                          if (!this.model["IsPostalData"]) {
                            e.component.beginUpdate();
                            e.component.option("value", this.getSetAsPostal());
                            e.component.endUpdate();
                          }
                        },
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "Postal Address",
                  colCount: 1,
                  visible: this.setVisible,
                  items: [
                    {
                      screenField: "MailAddressStreetLine1",
                      required: !this.model.SetAsPostalAddress,
                    },

                    {
                      screenField: "MailAddressStreetLine2",
                    },
                    {
                      screenField: "MailAddressSuburb",
                      required: !this.model.SetAsPostalAddress,
                    },
                    {
                      screenField: "MailAddressState",
                      required: !this.model.SetAsPostalAddress,
                    },
                    {
                      screenField: "MailAddressPostcode",
                      required: !this.model.SetAsPostalAddress,
                    },
                    {
                      screenField: "MailAddressCountry",
                      required: !this.model.SetAsPostalAddress,
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  items: [
                    {
                      screenField: "Currency",
                      required: true,
                      editorType: "dxSelectBox",
                      editorOptions: {
                        dataSource: CompanyService.dataSourceConfig(
                          "api/CompanyCurrency",
                          {
                            filter: [["Inactive", "=", "N"]],
                            sort: [{ selector: "Description", asc: true }],
                          }
                        ),
                        valueExpr: "CurrencyCode",
                        displayExpr: "Description",
                        searchExpr: ["CurrencyCode", "Description"],
                        searchMode: "contains",
                        searchEnabled: true,
                        itemTemplate: "currency-template",
                      },
                    },
                    {
                      screenField: "Abn",
                      required: true,
                    },
                    {
                      screenField: "Acn",
                      required: true,
                    },
                    {
                      screenField: "Gs1Code",
                    },
                    {
                      screenField: "Website",
                    },
                    {
                      screenField: "FriendlyName",
                      dataField: "FriendlyName",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "Email Details",
                  colCount: 1,
                  // required:true,
                  items: [
                    {
                      screenField: "DefaultEmail",
                      dataField: "DefaultEmail",
                      validationRules: [
                        {
                          type: "email",
                          message: "Email not in correct format.",
                        },
                        {
                          type: "required",
                          message: "Email is required.",
                        },
                      ],
                    },
                    {
                      screenField: "DefaultEmailAlias",
                      dataField: "DefaultEmailAlias",
                      validationRules: [
                        {
                          type: "required",
                          message: "Alias is required.",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  label: { visible: false },
                  dataField: "Image",
                  template: "image-uploader",
                },
              ],
            },
          ],
        },
      ];

      return items;
    },
  },

  methods: {
    clearMailAddress() {
      this.model.MailAddressCountry = "";
      this.model.MailAddressPostcode = "";
      this.model.MailAddressState = "";
      this.model.MailAddressStreetLine1 = "";
      this.model.MailAddressStreetLine2 = "";
      this.model.MailAddressSuburb = "";
    },

    getSetAsPostal() {
      this.model["IsPostalData"] = true;
      if (
        this.model["PhysicalAddressStreetLine1"] ==
          this.model["MailAddressStreetLine1"] &&
        this.model["PhysicalAddressStreetLine2"] ==
          this.model["MailAddressStreetLine2"] &&
        this.model["PhysicalAddressSuburb"] ==
          this.model["MailAddressSuburb"] &&
        this.model["PhysicalAddressState"] == this.model["MailAddressState"] &&
        this.model["PhysicalAddressPostcode"] ==
          this.model["MailAddressPostcode"] &&
        this.model["PhysicalAddressCountry"] == this.model["MailAddressCountry"]
      ) {
        this.model["SetAsPostalAddress"] = true;
        return true;
      } else {
        this.model["SetAsPostalAddress"] = false;
        return false;
      }
    },
  },
};
</script>
